import React, { useEffect } from 'react';
//import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ServicesButtonList from '../components/ServicesButtonList';
import Schema from '../components/Schema';

const Services = () => {
  // Data for services
  // const services = [
  //   {
  //     title: 'PV Installation - Type SCI method',
  //     description: 'We Protect & Provide Total Solar Care For Our National Solar Heroes.',
  //   },
  //   {
  //     title: 'Preventive maintenance',
  //     description: 'We Protect & Provide Total Solar Care For Our National Solar Heroes.',
  //   },
  //   {
  //     title: 'Panel cleaning',
  //     description: 'We Protect & Provide Total Solar Care For Our National Solar Heroes.',
  //   },
  //   {
  //     title: 'Health report',
  //     description: 'We Protect & Provide Total Solar Care For Our National Solar Heroes.',
  //   },
  //   {
  //     title: 'Handling manufacturers warranty',
  //     description: 'We Protect & Provide Total Solar Care For Our National Solar Heroes.',
  //   },
  //   {
  //     title: 'Bird proofing',
  //     description: 'We Protect & Provide Total Solar Care For Our National Solar Heroes.',
  //   },
  //   {
  //     title: 'Semi automatic cleaning system',
  //     description: 'Authorized Exclusive Distributor Of Chemitek SA Portugal For Sri Lanka & Maldives.',
  //   },
  //   {
  //     title: 'Fully automated cleaning system',
  //     description: 'Tuv Sud Tested & Certified By Top 16 Panel Manufacturers In The World.',
  //   },
  //   {
  //     title: 'Domestic, commercial, industrial pv consultation',
  //     description: 'Introducer Of Bird Proofing On Solar Panels To Sri Lanka.',
  //   },
  // ];

  // Data for renewable energy percentages
  // const percentages = [
  //   { label: 'Solar', value: 90 },
  //   { label: 'Wind', value: 80 },
  //   { label: 'Hydro', value: 85 },
  //   { label: 'Green', value: 88 },
  // ];

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      easing: 'ease-in-out', // animation easing
      once: true, // whether animation should happen only once - while scrolling down
    });
  }, []);


  return (
    <div>
  <Schema />
        <ServicesButtonList/>

        {/* Sample Article Section */}
      <section className="px-6 py-14 max-w-6xl mx-auto">
        <div className="space-y-14 text-justify">
          <article>
            <h2 className="text-5xl font-bold mb-4 text-black text-center">Semi-Automatic Cleaning System</h2>
            <p className="text-gray-700 text-lg">
              As the <strong>Authorized Exclusive Distributor of ChemiTek SA Portugal</strong> for Sri Lanka and the Maldives,
              Solar Care International now offers Semi-Automatic Cleaning Systems designed to simplify solar panel maintenance.
              These systems provide a cost-effective, labor-saving solution for solar plant operators by combining professional-grade
              cleaning tools with ChemiTek’s advanced chemical products.
            </p>
            <p className="text-gray-700 text-lg mt-4">
              Ideal for rooftop and medium-scale PV installations, the semi-automatic system ensures consistent cleaning results
              while reducing wear and tear on your panels. This approach supports long-term efficiency and asset longevity.
            </p>
          </article>

          <article>
            <h2 className="text-5xl font-bold mb-4 text-black text-center">Fully Automated Cleaning System</h2>
            <p className="text-gray-700 text-lg">
              Our Fully Automated Cleaning Systems have been <strong>TÜV SÜD tested</strong> and are <strong>certified by the top 16 solar panel manufacturers</strong> worldwide.
              These state-of-the-art robotic cleaning solutions operate autonomously, requiring zero manual labor, and are
              particularly suited for utility-scale PV farms.
            </p>
            <p className="text-gray-700 text-lg mt-4">
              Equipped with smart scheduling, weather sensors, and AI-driven algorithms, the system maximizes solar yield,
              reduces water usage, and minimizes downtime. It’s the ultimate in operational efficiency and sustainability for large-scale energy producers.
            </p>
          </article>
        </div>
      </section>
      
      {/* Services Gallery */}
      {/* <div className="container mx-auto p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-aos="fade-up">
        {services.map((service, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-lg p-6"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-500" data-aos="fade-up">
              {service.title}
            </h3>
            <p className="text-slate-900" data-aos="fade-up">
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div> */}

<br/>

      {/* Renewable Energy Percentages */}
      {/* <h3 className="text-2xl font-bold text-center mb-8 bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-500" data-aos="fade-up">Being Green is Remaining Clean</h3> */}
      {/* <div className="flex flex-wrap justify-center gap-8">
        {percentages.map((item, index) => (
          <div key={index} className="w-32 h-32" data-aos="fade-up">
            <CircularProgressbar
              value={item.value}
              text={`${item.value}%`}
              styles={buildStyles({
                textSize: '16px',
                pathColor: `#4caf50`,
                textColor: '#333',
                trailColor: '#d6d6d6',
              })}
            />
            <div className="flex flex-col items-center mt-0.125" data-aos="fade-up">
              <p className="text-center mt-2 font-semibold">{item.label}</p>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
};


export default Services;
